/**
 * Shared GLSL building blocks for the ring-based fullscreen WebGL2 effects
 * ({@link ./RingTransitionFX}, {@link ./ImageRippleFX}). Both flip V in the vertex
 * stage so screen-space y=0 is the top edge, remap sampling with object-cover, and ease
 * their expanding ring with the same quadratic-out curve over the same duration. Kept
 * here so the two effects can't drift apart.
 */

/** Vertex shader: fullscreen triangle with V flipped so screen-space y=0 is the top edge. */
export const RING_VERTEX = /* glsl */ `#version 300 es
precision highp float;
in vec2 uv;
in vec3 position;
out vec2 vUv;
void main() {
    vUv = vec2(uv.x, 1.0 - uv.y);
    gl_Position = vec4(position, 1.0);
}
`;

/** GLSL helper: object-cover UV remap (fit a texture's aspect into the container, centred). */
export const GLSL_GET_COVER_UV = /* glsl */ `
vec2 getCoverUv(vec2 uv, vec2 containerRes, vec2 textureRes) {
    float containerAspect = containerRes.x / containerRes.y;
    float textureAspect = textureRes.x / textureRes.y;
    vec2 scale = vec2(1.0);
    if (containerAspect > textureAspect) scale.y = textureAspect / containerAspect;
    else scale.x = containerAspect / textureAspect;
    return (uv - 0.5) * scale + 0.5;
}
`;

/** GLSL helper: quadratic ease-out. */
export const GLSL_QUADRATIC_OUT = /* glsl */ `
float quadraticOut(float t) {
    return -t * (t - 2.0);
}
`;

/** Both ring effects animate a single transition over this many seconds. */
export const RING_TRANSITION_DURATION = 1;
